/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

/*COMPONENT*/
import Modal from "../../Components/common_modal/Modal";
import SpinnerSimpleBlue from "../../Components/common_spinner/SpinnerSimpleBlue";
import FLOAT_MENU from "../../Components/common_trivial/FLOAT_MENU";

import Yes from "../../Assets/svg/tick-circle.svg";

/*REDUX*/
import {
  logoutUser,
  openModal,
  resetSearchUser,
} from "../../App/actions/authActions";
import {
  addGroup,
  getGroups,
  deleteGroup,
  editGroup,
  searchUser,
  addMember,
  set_value_auth,
  push_value_auth,
  delete_value_auth,
} from "../../App/actions/groupActions";
import { getUserPaymentList } from "../../App/actions/paymentActions";
import {
  add_collaborator,
  get_collaborator,
  delete_collaborator,
  invite_collaborator,
} from "../../App/actions/license_actions";
import { set_value_user } from "../../App/actions/authActions";
import { block_license_with_handler, is_pass_license_sharing } from "../../App/actions/filter_license";

/*PICTURE*/
import ICON_PLUS from "../../Assets/jsx/ICON_PLUS";
import menu_icon from "../../Assets/svg/menu_icon.svg";
import icon_group from "../../Assets/svg/icon_group.svg";

/*FUNCTION*/
import isEqual from "../../App/validation/is-equal";
import isEmpty from "../../App/validation/is-empty";
import formatDate from "../../App/validation/format-date";

/*DATA*/
import dict from "../../Data/dict.json";


/*CONST*/
const WAIT_INTERVAL = 1000;
const ENTER_KEY = 13;

class GROUP_MENU extends Component {
  state = {
    user: {},
    modal_add_group: false,
    modal_delete: false,
    modal_edit: false,
    modal_add_member: false,
    modal_add_collaborator: false,
    name: "",
    group_state: null, // Will hold selected group object
    search_user: "",
    member_id: "",
    modal_device: false,
    collaborator_qty:
      this.props.license_reducer.license_basic?.collaborator_qty ||
      this.props.license_reducer.license_user_status?.collaborator_qty,
    current_collaborator_qty: this.props.auth.current_collaborator_qty,
    buttonInviteEmail: false,
    buttonInvitePhone: false,
    activeTab: "Member",
    modal_menu: false, // controls FLOAT_MENU visibility
    anchor: null, // anchor element for FLOAT_MENU positioning
    status_user: "", // user status relative to selected group
    modal_filter: false,
    roles: ["creator", "admin", "viewer", "contributor"],
    selectedRoles: ["creator", "admin", "viewer", "contributor"],
    group_types: ["internal", "external"],
    selected_group_types: ["internal", "external"],
    modal_roles_rules: false,
    is_external: false,
  };

  componentDidMount() {
    this.props.getUserPaymentList();
    this.props.getGroups();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.license_reducer?.license_basic?._id ||
      this.props.license_reducer?.license_user_status?._id ||
      this.props.license_reducer?.license_sharing?._id
    ) {
      if (
        prevProps?.license_reducer?.license_basic?._id !==
        this.props.license_reducer?.license_basic?._id &&
        this.props.license_reducer?.license_basic?._id
      ) {
        this.props.get_collaborator(
          this.props.license_reducer?.license_basic?._id
        );
      } else if (
        prevProps?.license_reducer?.license_user_status?._id !==
        this.props.license_reducer?.license_user_status?._id &&
        this.props.license_reducer?.license_user_status?._id
      ) {
        this.props.get_collaborator(
          this.props.license_reducer?.license_user_status?._id
        );
      } else if (
        prevProps?.license_reducer?.license_sharing?._id !==
        this.props.license_reducer?.license_sharing?._id &&
        this.props.license_reducer?.license_sharing?._id
      ) {
        this.props.get_collaborator(
          this.props.license_reducer?.license_sharing?._id
        );
      }
    }

    // lisensi lama
    const old_qty =
      this.props.license_reducer.license_user_status?.collaborator_qty;
    const license_old_qty =
      prevProps.license_reducer.license_user_status?.collaborator_qty !==
      this.props.license_reducer.license_user_status?.collaborator_qty;

    // lisensi baru
    const new_qty = this.props.license_reducer.license_basic?.collaborator_qty;
    const license_new_qty =
      prevProps.license_reducer.license_basic?.collaborator_qty !==
      this.props.license_reducer.license_basic?.collaborator_qty;

    const old_condition = license_old_qty && old_qty !== undefined;
    const new_condition = license_new_qty && new_qty !== undefined;
    if (old_condition) {
      this.setState({
        collaborator_qty: old_qty,
      });
    } else if (new_condition) {
      this.setState({
        collaborator_qty: new_qty,
      });
    }

    const prevCollabLength = prevProps.auth.collaborators.length;
    const currentCollabLength = this.props.auth.collaborators.length;

    if (
      prevCollabLength !== currentCollabLength &&
      this.state.current_collaborator_qty !== currentCollabLength
    ) {
      this.setState({
        current_collaborator_qty: currentCollabLength,
      });
      this.props.set_value_auth({
        key: "current_collaborator_qty",
        value: currentCollabLength,
      });
    }
    // Close modal_add_group or modal_edit if groups changed
    const { groups } = this.props.auth;
    const groups_prev = prevProps.auth.groups;
    if (!isEqual(groups, groups_prev)) {
      this.setState({ modal_add_group: false, modal_edit: false });
    }
    // Update user state on auth user changes
    const prev_user =
      prevProps.auth && prevProps.auth.user ? prevProps.auth.user : {};
    const this_user =
      this.props.auth && this.props.auth.user ? this.props.auth.user : {};
    if (!isEqual(prev_user, this_user)) {
      this.setState({ user: this_user });
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const next_user =
      nextProps.auth && nextProps.auth.user ? nextProps.auth.user : {};
    const this_user = prevState.user;
    if (!isEqual(next_user, this_user)) {
      return {
        user: this_user,
      };
    }
    return null;
  }

  toggle_payment_universal = () => {
    const { modal_payment_universal } = this.props.auth;
    this.props.set_value_user(
      "modal_payment_universal",
      !modal_payment_universal
    );
  };

  toggle_login = () => {
    const { modal_login } = this.props.auth;
    this.props.set_value_user("modal_login", !modal_login);
  };

  onOpenModal = (name) => {
    this.props.openModal(name);
  };

  toggle_edit = (group) => {
    if (this.props.is_pass_license_sharing()) {
      if (group) {
        this.setState({
          group_state: group,
          name: group.name,
          is_external: group.is_external,
        });
      }
      this.setState({
        modal_edit: !this.state.modal_edit,
        modal_add_member: false,
        modal_menu: false,
        anchor: null,
      });
    } else {
      this.props.block_license_with_handler();
      this.setState({
        modal_edit: false,
        modal_add_member: false,
        modal_menu: false,
        anchor: null,
      });
    }
  };

  toggle_delete = (type, group) => {
    const language = localStorage?.language || "ina";
    const { collaborators } = this.props.auth;

    if (type === "group") {
      if (group) {
        this.setState({ group_state: group });
      }
      this.setState({
        modal_delete: !this.state.modal_delete,
        modal_add_member: false,
        modal_menu: false,
        anchor: null,
        contentDelete: (
          <div className="box-body" style={{ textAlign: "center" }}>
            <p>{dict["Are you sure to delete this group?"][language]}</p>
            <br />
            <h2>{group.name}</h2>
            <br />
            <button
              className="button_very_small background_red"
              data-mapid="clickDeleteModal"
              onClick={this.onDeleteClick}
            >
              {dict["Delete"][language]}
            </button>
          </div>
        ),
      });
    } else if (type === "collaborator") {
      this.setState({
        contentDelete: (
          <div className="box-body" style={{ textAlign: "center" }}>
            <p>{"Are you sure to delete this collaborator?"}</p>
            <br />
            <h2>{group.full_name}</h2>
            <br />
            <button
              className="button_very_small background_red"
              data-mapid="clickDeleteModal"
              onClick={this.onDeleteCollaborator}
            >
              {dict["Delete"][language]}
            </button>
          </div>
        ),
      });
      const { license_basic, license_user_status } = this.props.license_reducer;
      const p_id = license_basic?._id || license_user_status?._id;

      this.props.delete_collaborator(group, collaborators, p_id);
    }
  };

  onDeleteClick = () => {
    const { group_state } = this.state;
    const content = {
      group_id: group_state._id,
    };
    this.props.deleteGroup(content);
    this.setState({
      modal_delete: false,
      group_state: null,
    });
  };

  onDeleteCollaborator = () => {
    // placeholder if needed
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
    if (name === "search_user") {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.props.searchUser(value);
      }, 2000);
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { name } = this.state;
    const {
      license_basic,
      license_sharing,
      license_group_status,
      license_user_status,
    } = this.props.license_reducer;

    const collaborator_id =
      license_sharing?.collaborator_id ||
      license_group_status?.collaborator_id ||
      license_basic?.collaborator_id ||
      license_user_status?.collaborator_id;

    const content = {
      name,
      collaborator_id,
      is_external: this.state.is_external,
    };

    this.props.addGroup(content);
  };

  handleSubmitEdit = (e) => {
    e.preventDefault();
    const { name, group_state, is_external } = this.state;
    const content = {
      group_name: name,
      group_id: group_state._id,
      is_external: is_external,
    };
    this.props.editGroup(content);
    this.setState({ modal_edit: false, group_state: null });
  };

  setActiveTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  toggle_add_group = () => {
    if (this.props.is_pass_license_sharing()) {
      this.setState({
        modal_add_group: !this.state.modal_add_group,
      });
    } else {
      this.props.block_license_with_handler();
    }
  };

  // kayanya nggak dipake
  toggle_add_collaborator = () => {
    this.on_reset_search();
    if (this.props.is_pass_license_sharing()) {
      this.setState({
        modal_add_collaborator: !this.state.modal_add_collaborator,
      });
    } else {
      this.props.block_license_with_handler();
      this.setState({
        modal_add_collaborator: !this.state.modal_add_collaborator,
      });
    }
  };

  toggleDevice = () => {
    this.setState({
      modal_device: !this.state.modal_device,
    });
  };

  on_change_search_user = (e) => {
    const { name, value } = e.target;
    clearTimeout(this.timer);
    this.setState({ [name]: value });

    this.timer = setTimeout(() => this.trigger_change(), WAIT_INTERVAL);
  };

  on_key_down = (e) => {
    if (e.keyCode === ENTER_KEY) {
      this.trigger_change();
    }
  };

  trigger_change = () => {
    const { search_user } = this.state;

    const isEmail = /\S+@\S+\.\S+/.test(search_user);
    const isPhone = /^[0-9]{9,15}$/.test(search_user);

    if (isEmail) {
      this.setState({ buttonInviteEmail: true });
    } else if (isPhone) {
      this.setState({ buttonInvitePhone: true });
    } else {
      this.setState({ buttonInviteEmail: false, buttonInvitePhone: false });
    }

    this.props.searchUser(search_user);
  };

  on_reset_search = () => {
    this.setState({ search_user: "" }, () => {
      this.props.resetSearchUser();
    });
  };

  on_push_member = (_id, name, full_name, profile_picture) => {
    const body = { _id, name, full_name, profile_picture };
    const { collaborators, current_collaborator_qty } = this.props.auth;
    const { collaborator_qty } = this.state;
    const { license_basic, license_user_status } = this.props.license_reducer;
    const p_id = license_basic?._id || license_user_status?._id;
    this.props.add_collaborator(
      body,
      collaborators,
      current_collaborator_qty,
      collaborator_qty,
      p_id
    );
  };

  handleInvite = () => {
    const language = localStorage?.language || "ina";
    const { search_user, buttonInviteEmail } = this.state;
    const via = buttonInviteEmail ? "email" : "phone";
    const { license_basic, license_user_status } = this.props.license_reducer;
    const payment_id = license_basic?._id || license_user_status?._id;
    this.props.invite_collaborator(payment_id, search_user, via, language);
    this.setState({ buttonInviteEmail: false, buttonInvitePhone: false });
  };

  toggle_menu = (event) => {
    if (event) {
      event.preventDefault();
      const group_id = event.currentTarget?.dataset?.groupId;
      const group = this.props.auth.groups.find((g) => g._id === group_id);

      if (!group) return; // Safety check

      // Find current user's status for this group
      const member = group.members.find(
        (m) => (m?.user?._id ? m.user._id : m?.user) === this.state.user._id
      );
      const status_user =
        member && member.status && member.status !== "accepted"
          ? member.status
          : "viewer";

      this.setState({
        modal_menu: !this.state.modal_menu,
        anchor: event.currentTarget,
        group_state: group,
        status_user,
      });
    } else {
      this.setState({
        modal_menu: false,
        anchor: null,
        group_state: null,
        status_user: "",
      });
    }
  };
  toggle_filter = (event) => {
    if (event) {
      this.setState({
        modal_filter: !this.state.modal_filter,
        anchor: event.currentTarget,
      });
    } else {
      this.setState({
        modal_filter: false,
        anchor: null,
      });
    }
  };
  setFilter = (dt) => {
    let { selectedRoles, selected_group_types } = this.state;

    if (selectedRoles.includes(dt.role)) {
      //hapus

      selectedRoles = selectedRoles.filter((item) => item !== dt.role);
      this.setState({ selectedRoles: selectedRoles });
    } else if (selected_group_types.includes(dt.type)) {
      selected_group_types = selected_group_types.filter(
        (item) => item !== dt.type
      );
      this.setState({ selected_group_types: selected_group_types });
    } else if (dt.role === "All") {
      if (selectedRoles.length > 0) {
        this.setState({ selectedRoles: [], selected_group_types: [] });
      } else {
        this.setState({
          selectedRoles: ["creator", "admin", "viewer", "contributor"],
          selected_group_types: ["internal", "external"],
        });
      }
    } else {
      this.setState({
        selectedRoles: [...selectedRoles, dt.role],
        selected_group_types: [...selected_group_types, dt.type],
      });
    }
  };
  rolesRule = () => {
    this.setState({ modal_roles_rules: !this.state.modal_roles_rules });
  };

  render() {
    const language = localStorage?.language || "ina";
    const {
      name,
      modal_menu,
      anchor,
      group_state,
      modal_filter,
      roles,
      selectedRoles,
      modal_roles_rules,
      group_types,
      selected_group_types,
    } = this.state;

    const { loading, loadingDetail, groups, user } = this.props.auth;
    const {
      license_basic,
      license_sharing,
      license_user_status,
      license_group_status,
    } = this.props.license_reducer;

    let group_list_content;
    let icon_edit_content;
    let loading_content;

    let icon_content = (
      <button
        className="button background_black"
        onClick={this.handleSubmit}
        type="submit"
        data-mapid="clickSave"
      >
        {dict["Save"][language]}
      </button>
    );

    if (loadingDetail && isEmpty(groups)) {
      loading_content = (
        <SpinnerSimpleBlue
          width={200}
          unik="loading_item_list"
          marginTop="0px"
          center={true}
          border={0.1}
        />
      );
    } else if (!isEmpty(groups)) {
      if (loading) {
        icon_content = (
          <SpinnerSimpleBlue
            width={48}
            unik="loading_item_list"
            marginTop="0px"
            center={true}
            border={0.1}
          />
        );
        icon_edit_content = (
          <SpinnerSimpleBlue
            width={48}
            unik="loading_item_list"
            marginTop="0px"
            center={true}
            border={0.1}
          />
        );
      } else {
        icon_edit_content = (
          <button
            className="button background_black margin_top"
            type="submit"
            onClick={this.handleSubmitEdit}
            data-mapid="clickSaveEdit"
          >
            {dict["Save"][language]}
          </button>
        );
      }

      // let selectedGroup = groups.filter((group) => {
      //   const { members } = group;
      //   const member = members.find(
      //     (member) =>
      //       (member?.user?._id ? member?.user?._id : member?.user) === user._id
      //   );

      //   const status_user =
      //     member && member?.status && member?.status !== "accepted"
      //       ? member.status
      //       : "viewer";

      //   return selectedRoles.includes(status_user);
      // });
      let selectedGroup = groups.filter((group) => {
        const { members = [], is_external } = group;

        // cari membership user
        const member = members.find(
          (member) =>
            (member?.user?._id ? member?.user?._id : member?.user) === user._id
        );

        // user tidak ada di group → exclude
        if (!member) return false;

        // mapping status ke role
        const status_user =
          member?.status && member.status !== "accepted"
            ? member.status
            : "viewer";

        // group type based on is_external
        const group_type = is_external ? "external" : "internal";

        // cek role
        const matchRole = selectedRoles.includes(status_user);

        // cek group type
        const matchType = selected_group_types.includes(group_type);

        return matchRole && matchType;
      });

      // console.log("selectedGroup", selectedRoles, selected_group_types);
      group_list_content = (
        <main
          style={{
            display: "inline-block",
            verticalAlign: "top",
          }}
        >
          {selectedGroup.map((group, idx) => {
            const { name, members, _id, date, is_external } = group;

            const member = members.find(
              (member) =>
                (member?.user?._id ? member?.user?._id : member?.user) ===
                user._id
            );
            const status_user =
              member && member?.status && member?.status !== "accepted"
                ? member.status
                : "viewer";

            return (
              <main
                className="container_project background_white outline_grey"
                key={idx}
                style={{ verticalAlign: "top", position: "relative" }}
              >
                <section
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  <div id="part_1" style={{ flex: 1, overflow: "hidden" }}>
                    <p
                      className={`badge margin_right margin_bottom green_container`}
                    >
                      {members.length}{" "}
                      {members.length > 1 ? "members" : "member"}
                    </p>
                  </div>
                  <div
                    id="part_2"
                    style={{ width: "50px", textAlign: "right" }}
                  >
                    {status_user === "creator" && (
                      <button
                        onClick={this.toggle_menu}
                        data-group-id={_id}
                        className="button button_white"
                        style={{ width: "30px" }}
                        data-mapid={`group_${idx}_toggle`}
                      >
                        <img alt="menu" src={menu_icon} height={15} />
                      </button>
                    )}
                  </div>
                </section>

                <section>
                  <p
                    className="text_bold"
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={name}
                  >
                    {name}
                  </p>
                </section>
                <section>
                  <div>
                    <p
                      className={`badge margin_bottom ${
                        //1
                        is_external ? "dark_blue_container" : "grey_container"
                        }`}
                    >
                      {`${is_external ? "External Group" : "Internal Group"}`}
                    </p>
                  </div>
                </section>

                <section
                  style={{
                    position: "absolute",
                    bottom: 5,
                    boxSizing: "border-box",
                    width: "calc( 100% - 30px )",
                    padding: 0,
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "transparent",
                      borderTop: "2px solid #e6e6e6",
                      marginBottom: 5,
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      alignItems: "flex-start",
                    }}
                  >
                    <section
                      id="part_1"
                      style={{ flex: 1, paddingRight: "10px" }}
                    >
                      <p className="text_small margin_bottom">
                        {date && (
                          <>
                            {dict["Created at"][language]}: {formatDate(date)}
                          </>
                        )}
                      </p>
                      <br />
                      <button onClick={this.rolesRule}>
                        <p
                          className={`badge margin_bottom ${
                            //1
                            ["owner"].includes(status_user)
                              ? "dark_blue_container"
                              : //2
                              ["admin"].includes(status_user)
                                ? "green_container"
                                : //3
                                ["creator"].includes(status_user)
                                  ? "orange_container"
                                  : //4
                                  ["contributor"].includes(status_user)
                                    ? "blue_container"
                                    : //5
                                    "grey_container"
                            }`}
                        >
                          {status_user.charAt(0).toUpperCase() +
                            status_user.slice(1)}
                        </p>
                      </button>
                    </section>

                    <section id="part_2" style={{ width: "50px" }}>
                      <Link to={`/group/${_id}`}>
                        <div
                          className="text_below_icon"
                          style={{
                            marginRight: "15px",
                            textAlign: "center",
                            width: "100%",
                          }}
                        >
                          <img
                            src={icon_group}
                            height="30px"
                            alt="Group"
                            data-mapid={`clickGroupDetail-${idx}`}
                          />
                          <p style={{ margin: 0 }}>Detail</p>
                        </div>
                      </Link>
                    </section>
                  </div>
                </section>
              </main>
            );
          })}
        </main>
      );
    }

    const modalDelete = this.state.modal_delete && (
      <Modal
        modalSize="small"
        isOpen={this.state.modal_delete}
        onClose={() => this.setState({ modal_delete: false })}
      >
        {this.state.contentDelete}
      </Modal>
    );

    const modalEdit = this.state.modal_edit && (
      <Modal
        modalSize="small"
        isOpen={this.state.modal_edit}
        onClose={() => this.setState({ modal_edit: false })}
      >
        <div>
          <button
            className={`${this.state.is_external ? "checklist_active" : "checklist_not"
              }  margin_bottom margin_right`}
            onClick={() => {
              this.setState({ is_external: !this.state.is_external });
            }}
          />
          external group
        </div>
        <div className="box-body" style={{ textAlign: "center" }}>
          <form onSubmit={this.handleSubmitEdit}>
            <input
              className="input_square"
              type="text"
              name="name"
              id="name"
              value={name}
              onChange={this.handleChange}
              data-mapid="editInputGroup"
              autoFocus
            />
            <div style={{ marginTop: 15 }}>{icon_edit_content}</div>
          </form>
        </div>
      </Modal>
    );

    let create_group_content = <p>Pending</p>;

    if (
      license_basic?.is_has_license ||
      license_sharing?.is_has_license ||
      license_user_status?.is_has_license ||
      license_group_status?.is_has_license
    ) {
      create_group_content = (
        <main>
          <h1 className="text_header">
            {dict["Create a new group"][language]}
          </h1>
          <br />
          <br />
          <div>
            <button
              className={`${this.state.is_external ? "checklist_active" : "checklist_not"
                }  margin_bottom margin_right`}
              onClick={() => {
                this.setState({ is_external: !this.state.is_external });
              }}
            />
            external group
          </div>
          <form onSubmit={this.handleSubmit}>
            <div className="form-group">
              <input
                className="input_square"
                type="text"
                name="name"
                id="name"
                value={name}
                onChange={this.handleChange}
                data-mapid="inputNamaGroup"
                autoFocus
              />
              <div className="text-center" style={{ marginTop: 15 }}>
                {icon_content}
              </div>
            </div>
          </form>
        </main>
      );
    }

    const modal_add_group = this.state.modal_add_group && (
      <Modal
        modalSize="small"
        isOpen={this.state.modal_add_group}
        onClose={() => this.setState({ modal_add_group: false })}
      >
        <div className="box-body">{create_group_content}</div>
      </Modal>
    );

    // FLOAT_MENU usage:
    const floatMenuContent = (
      <FLOAT_MENU
        id="group-list-float-menu"
        anchorEl={anchor}
        open={modal_menu}
        onClose={this.toggle_menu}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        style={{ borderRadius: "15px" }}
      >
        <div>
          <button
            className="button margin_bottom button_white"
            onClick={() => this.toggle_edit(group_state)}
            data-mapid="clickEditGroup"
            style={{ width: "100%", textAlign: "left" }}
          >
            {dict["Edit"][language]}
          </button>

          <button
            className="button button_white"
            onClick={() => this.toggle_delete("group", group_state)}
            data-mapid="clickDeleteGroup"
            style={{ width: "100%", textAlign: "left" }}
          >
            {dict["Delete"][language]}
          </button>
        </div>
      </FLOAT_MENU>
    );

    const filterContent = (
      <FLOAT_MENU
        id="filter-float-menu"
        anchorEl={anchor}
        open={modal_filter}
        onClose={this.toggle_filter}
      >
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td>
                <button
                  className={
                    selectedRoles.length === roles.length
                      ? "checklist_active"
                      : "checklist_not"
                  }
                  onClick={this.setFilter.bind(this, { role: "All" })}
                />
              </td>
              <td className="side">{dict?.["All"]?.[language] || "All"}</td>
            </tr>
            {roles.map((dt, index) => {
              return (
                <tr key={index}>
                  <td>
                    <button
                      className={
                        selectedRoles.includes(dt)
                          ? "checklist_active"
                          : "checklist_not"
                      }
                      onClick={this.setFilter.bind(this, { role: dt })}
                    />
                  </td>
                  <td className="side">{dt}</td>
                </tr>
              );
            })}
            {group_types.map((dt, index) => {
              return (
                <tr key={index}>
                  <td>
                    <button
                      className={
                        selected_group_types.includes(dt)
                          ? "checklist_active"
                          : "checklist_not"
                      }
                      onClick={this.setFilter.bind(this, { type: dt })}
                    />
                  </td>
                  <td className="side">{dt}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </FLOAT_MENU>
    );
    const modal_roles_rules_content = modal_roles_rules && (
      <Modal
        modalSize="medium"
        isOpen={this.state.modal_roles_rules}
        onClose={() => this.setState({ modal_roles_rules: false })}
      >
        <div style={{ overflowX: "auto" }}>
          <h2 style={{ marginBottom: "20px", fontFamily: "sans-serif" }}>
            Aturan Role Grup
          </h2>

          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "sans-serif",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr style={{ background: "#f5f5f5", textAlign: "left" }}>
                <th style={{ padding: "10px", border: "1px solid #ddd" }}></th>
                {roles.map((dt) => {
                  return (
                    <th style={{ padding: "10px", border: "1px solid #ddd" }}>
                      <p
                        className={`badge margin_bottom ${
                          //1
                          ["owner"].includes(dt)
                            ? "dark_blue_container"
                            : //2
                            ["admin"].includes(dt)
                              ? "green_container"
                              : //3
                              ["creator"].includes(dt)
                                ? "orange_container"
                                : //4
                                ["contributor"].includes(dt)
                                  ? "blue_container"
                                  : //5
                                  "grey_container"
                          }`}
                      >
                        {dt}
                      </p>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {[
                [
                  dict?.["Deleting a group"]?.[language],
                  "ya",
                  "tidak",
                  "tidak",
                  "tidak",
                ],
                [
                  dict?.["Rename a group"]?.[language],
                  "ya",
                  "tidak",
                  "tidak",
                  "tidak",
                ],
                [
                  dict?.["Adding members to a group"]?.[language],
                  "ya",
                  "ya",
                  "tidak",
                  "tidak",
                ],
                [
                  dict?.["Changing member roles in a group"]?.[language],
                  "ya",
                  "tidak",
                  "tidak",
                  "tidak",
                ],
                [
                  dict?.["Delete member"]?.[language],
                  "ya",
                  "ya",
                  "tidak",
                  "tidak",
                ],
                [""], // pemisah
                [
                  dict?.["Adding a group to a project"]?.[language],
                  "ya",
                  "ya",
                  "tidak",
                  "tidak",
                ],
                [
                  dict?.["View the collaborative project editor map"]?.[
                  language
                  ],
                  "ya",
                  "ya",
                  "ya",
                  "tidak",
                ],
                [
                  dict?.["View the collaborative project map viewer"]?.[
                  language
                  ],
                  "ya",
                  "ya",
                  "ya",
                  "ya",
                ],
                [
                  dict?.["Submit the form in the collaboration project"]?.[
                  language
                  ],
                  "ya",
                  "ya",
                  "ya",
                  "ya",
                ],
              ].map((row, idx) =>
                row.length === 1 && row[0] === "" ? (
                  <tr key={idx}>
                    <td
                      colSpan={5} // jumlah kolom di tabel
                      style={{ background: "#eee", height: "10px", padding: 0 }}
                    />
                  </tr>
                ) : (
                  <tr
                    key={idx}
                    style={{
                      background: idx % 2 === 0 ? "#fff" : "#fafafa",
                    }}
                  >
                    {row.map((col, cIdx) => (
                      <td
                        key={cIdx}
                        style={{
                          padding: "10px",
                          border: "1px solid #ddd",
                          textAlign: "center",
                        }}
                      >
                        {col === "ya" ? (
                          <img src={Yes} alt="yes" width={20} />
                        ) : col === "tidak" ? (
                          "-"
                        ) : (
                          col
                        )}
                      </td>
                    ))}
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </Modal>
    );

    return (
      <main className="footer_margin">
        <div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <button
              onClick={this.toggle_add_group}
              className="button_pill background_white margin_bottom margin_right"
              data-mapid="clickNewGroup"
            >
              <span className="badge_circle background_green margin_right">
                <ICON_PLUS />
              </span>
              {dict["New Group"][language]}
            </button>
            <div>
              <button
                className="button_big background_white rounded"
                onClick={this.toggle_filter}
              >
                Filter
              </button>
              {filterContent}
            </div>
          </div>
          <br />
          {loading_content}
          {group_list_content}
          {modal_add_group}
          {modalDelete}
          {modalEdit}
          {floatMenuContent}
          {modal_roles_rules_content}
          <Helmet>
            <title>{dict["Group"][language]}</title>
            <meta name="description" content={dict["Group"][language]} />
          </Helmet>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  payment: state.payment,
  license_reducer: state.license_reducer,
});

export default connect(mapStateToProps, {
  addGroup,
  getGroups,
  deleteGroup,
  editGroup,
  searchUser,
  resetSearchUser,
  addMember,
  logoutUser,
  getUserPaymentList,
  openModal,
  set_value_user,
  set_value_auth,
  push_value_auth,
  delete_value_auth,
  add_collaborator,
  get_collaborator,
  delete_collaborator,
  invite_collaborator,
  is_pass_license_sharing,
  block_license_with_handler
})(GROUP_MENU);
